import { libraryManagedConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export const saveLibraryManagedProductGroupsOrder = async (slots: { slotId: number; slotIndex: number }) => {
    return await http
        .put<void>(libraryManagedConfig().endpointProductGroupsReorder, { slots })
        .then(response => response.data);
};
